import Alpine from "alpinejs";

const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

Alpine.data("newsletterForm", () => ({
    email: "",
    form: {
        "x-on:submit.prevent"() {
            this.$dispatch("openNewsletterModal", { email: this.email });
        },
    },
    submit: {
        ":disabled"() {
            return !EMAIL_REGEX.test(this.email);
        },
    },
}));

Alpine.data("newsletterModal", () => ({
    open: false,
    email: "",
    formRendered: false,
    modal: {
        "x-show"() {
            return this.open;
        },
        "x-trap.noscroll.inert"() {
            return this.open;
        },
        "@openNewsletterModal.window"() {
            console.log("openNewsletterModal.window");
            this.open = true;
            this.email = this.$event.detail.email;
        },
    },
}));
